(function () {
  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function updateTimer(root) {
    var hoursEl = root.querySelector('[data-ct-hours]');
    var minutesEl = root.querySelector('[data-ct-minutes]');
    var secondsEl = root.querySelector('[data-ct-seconds]');
    if (!hoursEl || !minutesEl || !secondsEl) return;

    var now = new Date();
    var midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
    var diff = midnight.getTime() - now.getTime();

    if (diff < 0) diff = 0;

    var totalSeconds = Math.floor(diff / 1000);
    var hours = Math.floor(totalSeconds / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;

    hoursEl.textContent = pad(hours);
    minutesEl.textContent = pad(minutes);
    secondsEl.textContent = pad(seconds);
  }

  function initTimer(root) {
    updateTimer(root);
    // Se actualiza cada segundo. Como siempre calcula contra la
    // próxima medianoche, se reinicia solo automáticamente cada día.
    setInterval(function () {
      updateTimer(root);
    }, 1000);
  }

  function initAll() {
    document.querySelectorAll('[data-ct-timer]').forEach(initTimer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var timers = e.target.querySelectorAll('[data-ct-timer]');
    timers.forEach(initTimer);
  });
})();